<div class="chart-container" *ngIf="windowSize != 'mobile'">
  <canvas #chart></canvas>
</div>

<div class="chart-container" style="height: 300px" *ngIf="windowSize == 'mobile'">
  <canvas #chart></canvas>
</div>
